<template>

    <v-modal :title="title">

        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Label">
                <v-input :model="params.label" @input="params.label = $event" />
            </v-form-group>
            <v-form-group v-if="!['checkbox'].includes(el.type)" dir="ver" label="Placeholder">
                <v-input :model="params.placeholder" @input="params.placeholder = $event" />
            </v-form-group>
            <v-form-group v-if="['text_short', 'text_long', 'checkbox'].includes(el.type)" dir="ver" label="Name">
                <v-input :model="params.name" @input="params.name = $event" />
            </v-form-group>
            <v-form-group v-if="['text_short', 'text_long'].includes(el.type)" dir="ver" label="Max Length">
                <v-input class="w-50p" :model="params.maxlength" @input="params.maxlength = $event" />
            </v-form-group>
            <v-form-group v-if="!['email'].includes(el.type)" dir="ver">
                <v-checkbox label="Require this field" :model="params.required" @input="params.required = $event" />
            </v-form-group>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="updateElement">Save</v-button>
        </template>

    </v-modal>

</template>

<script>

import { titleCase } from 'title-case';
import FormApi from '@api/FormApi';

export default {

    props: {
        el: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                label: this.el.label,
                name: this.el.name,
                placeholder: this.el.placeholder,
                maxlength: this.el.maxlength,
                required: this.el.required,
            },
        }
    },

    computed: {

        title() {
            return 'Edit ' + titleCase(this.el.type);
        },

        form() {
            return this.$store.getters['form/form'];
        },

    },

    methods: {

        updateElement() {
            this.loading = true;
            FormApi.updateElement(this.form.id, this.el.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('form/setElements', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
